export default __webpack_public_path__ + "static/media/create-ticket.a232ee03.svg";